import { Component } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';
import * as moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'satturno-app';

  constructor(private config: NgSelectConfig) {
    this.config.clearAllText = 'Limpar';
    this.config.loadingText = 'Carregando';
    this.config.notFoundText = 'Não encontrado';

    moment.locale('pt-br');
  }
}
